<template>
  <gofix-card class="mb-0 contractCardFullHeight" fullContent>
    <gofix-default-table
        :settings="tableConfig"
        :table-items="tableItems"
        @load-items="getTableData"
        ref="gofixTable">
      <template slot="gofix_table:effective_date" slot-scope="row">
        {{row.item.effective_date  | formatDatebyMoment("YYYY-MM-DD","DD.MM.YYYY")}}
      </template>
      <template slot="gofix_table:original_unit_price" slot-scope="row">
        {{ row.item.original_unit_price | formatMoney }}
      </template>
      <template slot="gofix_table:name_organization" slot-scope="row">
        {{ row.item.supplier ?  row.item.supplier.name : "" }}
      </template>
    </gofix-default-table>
  </gofix-card>
</template>
<script>
import { mapGetters } from 'vuex';
import { filters } from '@/_filterVar.js';

export default {
  name: 'sor-item-versionings',
  props:{
    sorItemId: {
      type: Number,
      required: true,
      default: () => 0
    },
  },
  data () {
    let filter = JSON.parse(JSON.stringify(filters['sor_versioning']));
    return {
      first_load: true,
      tableItems: [],
      tableConfig:{
        name: 'sor-item-versionings',
        controls:{
          create:false,
          delete: false,
          tableImport: false,
          tableExport: false
        },
        filter: filter,
        page: 1,
        limit: 100,
        total: 0,
        useDatabaseView: true,
        sortColumn: "effective_date",
        sortDirection: "asc",
        itemSelected: [],
      }
    }
  },
  computed: {
  },
  created(){
  },
  methods:{
    /*--- Table event-------------------------------*/
    async getTableData(callback){
      const { tableRequest , resolve,reject } = await callback();
      tableRequest.filter.sor_item_id.value = this.sorItemId
      await this.$store.dispatch("v2SorController/getVersioningItems", tableRequest)
          .then(response => {
            this.tableItems = response.items;
            this.tableConfig.total = response.total;
            resolve(response);
          })
          .catch(err => {
            this.$alertNotification("Can not load the items", "danger");
            reject();
          })
    },
  }
}
</script>
